import { useLocation } from 'react-router';

import { useLanguage } from '../../contexts/language';
import { useNavigation } from '../../hooks/navigation';

import styles from './style.module.css';

// The name of the section on screen, beside the mascot. A phone hides the
// links, so this is how it says where you are; a desktop already shows it on
// the highlighted link and hides this.
export function CurrentSection() {
  const { text } = useLanguage();
  const { pathname } = useLocation();
  const { home, sections, pages } = useNavigation();
  // Home included: it has no link to highlight, so this label is the only
  // place a phone says it is on Today or the Dashboard. A section's own
  // pages count as the section: a daily record under /diary/record/… is
  // still the Diary.
  const current = [ home ].concat(sections, pages).find(function({ path }) {
    return path === pathname || (path !== '/' && pathname.startsWith(`${ path }/`) === true);
  });

  if (current == null) {
    return <span className={ styles.label }></span>;
  }

  return <span className={ styles.label }>{ text[ current.label ] }</span>;
}
